<script>
import _ from 'lodash'
import moment from 'moment'
import formRules from '@/mixins/formRules'
import projectsAPI from '@/modules/projects/api/projects'
import ProjectFiles from "@/components/files/ProjectFiles";

export default {
  name: 'project-card',
  mixins: [formRules],
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isSaving: false,
    isFormValid: false,
    showConfirm: false,
    attempted: false,
    unneeded: false,
    completed: false,
    is_form_valid: false,
    files_open: false,
    shovelling: null,
    file_to_be_uploaded: null,
    file_id: null,
    file_type: null,
    taskCompleted: '',
    notes: '',
    noteSpacer: " - "
  }),
  computed: {
    today() {
      return moment().format('YYYY-MM-DD').toString()
    },
    now() {
      return moment().format('HH:mm:ss').toString()
    },
    getClass() {
      if (this.project.on_hold) {
        return 'red lighten-3'
      } else if (this.project.crew_visit_status === 'Completed') {
        return 'green lighten-3'
      } else if (this.project.crew_visit_status === 'Attempted') {
        return 'orange lighten-3'
      } else if (this.project.status === 'Omit' || this.project.status === 'Inactive' || this.project.status === 'Unstarted' || this.project.status === 'Ended') {
        return 'grey lighten-2'
      } else {
        return ''
      }
    },
    inactive() {
      return this.project.status === 'Inactive' || this.project.status === 'Unstarted' || this.project.status === 'Ended'
    },
    isSnow() {
      return this.project.division === "S";
    },
    isRockChip() {
      return this.project.project_detail.ice_melt_ok ||
        /\(rock\s*chip\)/i.test(this.project.name);
    },
    displayName() {
      return this.project.name.replace(/\s*\(rock\s*chip\)/gi, '').trim();
    },
  },
  methods: {
    getDirections() {
      // need to change this to primary geolocation, address secondary
      let URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.project.site_address + '+' + this.project.site_city
      window.open(URL, '_blank',)
    },
    getDivision(div) {
      return _.find(this.$store.state.misc.divisions, function (w) { return w.id === div })
    },
    async submit() {
      this.isSaving = true
      let projectCopy = _.cloneDeep(this.project)
      let newVisit = {
        // date and time are set automatically by the backend
        project: this.project.id,
        created_by: this.$store.state.auth.profile.id,
      }
      if (this.isSnow) {
        if (this.completed) {
          newVisit.notes = "Completed Snow Clearing" + (this.notes ? this.noteSpacer : "") + (this.notes ? this.notes : "")
          projectCopy.crew_visit_status = "Completed"
        } else if (this.attempted) {
          newVisit.notes = "Could not complete Snow Clearing" + (this.notes ? this.noteSpacer : "") + (this.notes ? this.notes : "")
          newVisit.is_attempted = true
          projectCopy.crew_visit_status = "Attempted"
        } else if (this.unneeded) {
          newVisit.notes = "Site Visited, but Snow Clearing not required" + (this.notes ? this.noteSpacer : "") + (this.notes ? this.notes : "")
          projectCopy.crew_visit_status = "Completed"
        }
      } else {
        if (this.completed) {
          newVisit.notes = "Completed Mow and Trim" + (this.notes ? this.noteSpacer : "") + (this.notes ? this.notes : "")
          projectCopy.crew_visit_status = "Completed"
        } else if (this.attempted) {
          newVisit.notes = "Could not complete Mow/Trim" + (this.notes ? this.noteSpacer : "") + (this.notes ? this.notes : "")
          newVisit.is_attempted = true
          projectCopy.crew_visit_status = "Attempted"
        }
      }
      await projectsAPI.createCrewVisitForProject(newVisit);

      this.$emit('update', projectCopy)
      this.isSaving = false
      this.showConfirm = false
    },
    recordVisit() {
      this.showConfirm = true
      this.completed = false
      this.attempted = false
      this.unneeded = false
      setTimeout(() => {
        this.$refs.form.reset()
      }, 50)
    },
    goToFiles() {
      this.files_open = true;
      console.log(this.project);
    },
    markAsCompleted() {
      this.completed = true
      this.unneeded = false
      this.attempted = false
    },
    markAsUnneeded() {
      this.unneeded = true
      this.completed = false
      this.attempted = false
    },
    markAsAttempted() {
      this.completed = false
      this.unneeded = false
      this.attempted = true
      setTimeout(() => {
        this.$refs.reason.focus()
      }, 100)
    },
  },
  components: {
    'project-files': ProjectFiles
  }
}
</script>

<template>
  <div>
    <v-card outlined :class="getClass">
      <v-toolbar height='6px' dark :color='isSnow ? "info" : "green"' flat></v-toolbar>

      <v-card-title class='mt-n3'>
        <v-icon v-if='project.on_hold' class='mr-1' :color='$icons.hold.color'>{{ $icons.hold.icon }}</v-icon>
        {{ displayName }}
        <v-icon left color='red' class='ml-1' v-if='project.project_detail.is_quickpay'>mdi-timer-outline</v-icon>
        <span v-if='isRockChip' title='Rock Chip Customer'
          style='display:inline-flex; align-items:center; margin-left:6px; vertical-align:middle; background:#E0E0E0; border-radius:4px; padding:2px;'>
          <svg style='height:24px;width:24px;' viewBox="0 0 122.88 78.87" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M90.4,28.29l.08.24.22.62.08.24L91,30l.08.24.19.56.08.23.18.53.08.23.17.5.08.23L92,33l.07.23.15.44.08.23.14.4.08.23.13.38.08.22.12.35.07.22L93,36l.07.21.11.31.07.21.1.29.07.2.09.26.07.2.09.25.07.19.08.23.06.18.07.21.06.18.07.2.06.17.07.18,0,.17.06.16.06.16,0,.15,0,.16,0,.14.05.15,0,.12,0,.15,0,.11,0,.14,0,.1,0,.13,0,.1,0,.12,0,.09,0,.12,0,.08,0,.11,0,.07,0,.1,0,.07,0,.1,0,.06,0,.09v.06l0,.09,0,0,0,.08v0l0,.09,0,.11v.25h0l0,.18v.5h0V44h0v.08h0v.29h0v.35h0v.13h0v.13h0v.15h0v.16h0v.17h0v.18h0V46h0v.22h0v.24c.07,5,6.36,11,5.2,14.44s4.68,9.9,6.56,14.71H98.63a3.31,3.31,0,0,0-.6-1.91L79.93,44.76l3-4.85,3.65-3.66,3.69-8.1h0l.08.14ZM92.19,27l30.28,48.39a2.17,2.17,0,0,1,.41,1.28,2.21,2.21,0,0,1-2.21,2.21H3.28A3.28,3.28,0,0,1,.53,73.79L47.26,1.66A3.16,3.16,0,0,1,48.37.5,3.29,3.29,0,0,1,52.9,1.55L78.46,42.41l10-15.35a2.07,2.07,0,0,1,.75-.78,2.2,2.2,0,0,1,3,.71ZM52.44,75.58H3.9L14.33,61.79l16-28L39.47,23.2l4.65-10.28,6-9.64h0l.12.2c.88,2.66,1.26,4.11,2,6.25.44,1.23,2.3,3.91,2.67,4.93,5.31,14.76,2.62,9.34,2.69,15.88.08,7.51,9.47,16.45,7.74,21.53-1.93,5.62,8.38,16.22,10.31,23.51Z"/></svg>
        </span>
        <v-spacer></v-spacer>
        <div v-if='isSnow && !project.crew_visit_status && !project.status && project.project_detail.driveway_rating'
          class='body-2 primary--text font-weight-bold'>
          {{ "(" + project.project_detail.driveway_rating_obj.rating.toFixed(1) + " rating) " +
            project.project_detail.driveway_rating_obj.time_on_site + " mins" }}
        </div>
        <v-chip label v-if='project.crew_visit_status === "Attempted"' xSmall color='warning' dark>Attempted</v-chip>
        <v-chip label v-if='project.crew_visit_status === "Completed"' xSmall color='success' dark>Completed</v-chip>
        <v-chip label v-if='inactive' xSmall class='ml-1' color='grey darken-2' dark>Inactive</v-chip>
        <v-chip label v-if='project.status === "Omit"' class='ml-1' xSmall color='purple darken-4' dark>Off
          week</v-chip>
        <!-- this is the icon slot -->
      </v-card-title>

      <v-card-subtitle class='pb-0 grey--text' :class='inactive ? "" : " text--darken-2"'>
        {{ project.site_address }}
        <span v-if='project.site_city'>, {{ project.site_city }}</span>
      </v-card-subtitle>

      <v-card-text class='pb-1 pt-0' v-if='project.field_instructions'>
        <span v-html='project.field_instructions' class='info--text font-weight-bold font-italic'></span>
      </v-card-text>

      <v-card-text v-if='project.on_hold' class='error--text font-weight-bold pb-0'>This project is on hold - DO NOT
        DO</v-card-text>

      <v-card-actions class='px-4'>
        <v-btn width='44%' small style='border: lightgrey solid 1px !important;' color='blue lighten-5' elevation='0'
          @click='getDirections'>
          Directions
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn width='44%' small style='border: lightgrey solid 1px !important;' color='indigo lighten-5' elevation='0'
          @click='recordVisit'>
          Record Visit
        </v-btn>
      </v-card-actions>
      <v-card-actions class='px-4'>
        <v-btn width='100%' small style='border: lightgrey solid 1px !important;' color='blue lighten-5' elevation='0'
          @click='goToFiles'>
          View Files
        </v-btn>
      </v-card-actions>

    </v-card>

    <wc-dialog :showDialog='showConfirm' title='Record your visit'
      :disableButtons='!isFormValid || (!attempted && !completed && !unneeded)' :loadingButtons='isSaving'
      @cancel='showConfirm = false' @save='submit' :saveText='inactive ? "Save?" : "Save"'
      :saveColor='inactive ? "error" : "primary"' width='350'>
      <v-form ref='form' v-model='isFormValid' :disabled='isSaving'>
        <v-row>
          <v-col cols='12'>
            <v-btn block depressed color='primary' :disabled='completed' :loading='isSaving' @click='markAsCompleted'>
              <v-icon v-if='completed' left>mdi-check</v-icon>
              <span v-if='isSnow'>{{ completed ? "Marked as Complete" : "Completed Shovelling" }}</span>
              <span v-else>{{ completed ? "Marked as Complete" : "Completed Mow & Trim" }}</span>
            </v-btn>
          </v-col>

          <v-col cols='12' v-if='isSnow'>
            <v-btn block depressed color='info' :disabled='unneeded' :loading='isSaving' @click='markAsUnneeded'>
              <v-icon v-if='unneeded' left>mdi-check</v-icon>
              <span>{{ unneeded ? "Marked as Not Required" : "Shovelling Not Required" }}</span>
            </v-btn>
          </v-col>

          <v-col cols='12'>
            <v-btn block depressed color='warning' :disabled='attempted' :loading='isSaving' @click='markAsAttempted'>
              <v-icon v-if='attempted' left>mdi-check</v-icon>
              {{ attempted ? "Marked as Attempted" : "Could not complete" }}
            </v-btn>
          </v-col>
          <v-col cols='12'>
            <v-textarea ref='reason' v-model='notes'
              :label='attempted ? "Reason you could not complete" : "Additional notes for this visit?"'
              :rules='attempted ? [rules.required] : []' outlined
              :hint='attempted ? "Be descriptive so the office understands the situation" : ""'
              persistent-hint></v-textarea>
          </v-col>
          <div v-if='inactive' class='mx-4 caption error--text font-weight-bold'>This site is inactive<br>Are you sure
            you want to record a visit?</div>
          <div v-if='project.on_hold' class='mx-4 caption error--text font-weight-bold'>This project is on hold</div>
        </v-row>
      </v-form>
    </wc-dialog>
    <wc-dialog :showDialog='files_open' title='Project Files' :loadingButtons='isSaving' @save='files_open = false' saveText="Close" :hideCancel='true'
      :saveColor='inactive ? "error" : "primary"' width='480'>
        <project-files v-if='project' :files='project.project_file_data' :project_id='project.id'
          :disabled='project.archived'></project-files>
    </wc-dialog>
  </div>
</template>
